import { render, staticRenderFns } from "./aAccessControlList.vue?vue&type=template&id=abb4b0a4&scoped=true"
import script from "./aAccessControlList.vue?vue&type=script&lang=js"
export * from "./aAccessControlList.vue?vue&type=script&lang=js"
import style0 from "./aAccessControlList.vue?vue&type=style&index=0&id=abb4b0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb4b0a4",
  null
  
)

export default component.exports